// @flow
import * as React from 'react';

import type { State } from '../types';
import { initialState } from './reducer';

export default React.createContext<State>(initialState);
